import type { NoyoGroupPlan } from 'enrollment-platform/api/partner-benefit-graph/noyo-differences.types'
import React from 'react'
import { formatPlanDate } from './noyoPlanLabel'

const highlightedDateStyle: React.CSSProperties = {
  backgroundColor: '#ffe58f',
  color: '#613400',
  fontWeight: 600,
  padding: '0 3px',
  borderRadius: 4,
}

type PlanLabelProps = {
  plan: NoyoGroupPlan
  highlightStart?: boolean
  highlightEnd?: boolean
}

function DatePart({
  value,
  highlight,
  title,
}: {
  value: string
  highlight: boolean
  title: string
}) {
  if (highlight === false) {
    return <span>{value}</span>
  }
  return (
    <mark
      data-plan-date-highlight="true"
      title={title}
      style={highlightedDateStyle}
    >
      {value}
    </mark>
  )
}

export function PlanLabel({
  plan,
  highlightStart = false,
  highlightEnd = false,
}: PlanLabelProps) {
  if (plan.name.length === 0) {
    return null
  }
  const start = formatPlanDate(plan.effectiveStartDate)
  const end = formatPlanDate(plan.effectiveEndDate)
  const dates =
    highlightStart || highlightEnd ? (
      <>
        (
        <DatePart
          value={start}
          highlight={highlightStart}
          title="SureCo starts before Noyo"
        />
        -
        <DatePart
          value={end}
          highlight={highlightEnd}
          title="SureCo ends after Noyo"
        />
        )
      </>
    ) : (
      `(${start}-${end})`
    )
  return (
    <span style={{ whiteSpace: 'pre-line' }}>
      {plan.lineOfCoverage.length > 0 ? `(${plan.lineOfCoverage})\n` : null}
      {plan.name}
      {'\n'}
      {dates}
    </span>
  )
}
